import { render } from "./DragonKitRequiredMaterials.vue?vue&type=template&id=011eb34f"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__